import React from 'react';
import { CheckCircleIcon, XCircleIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

const PaymentStep = ({ 
    paymentStatus, 
    paymentError, 
    isProcessing,
    onRetry 
}) => {
    if (isProcessing) {
        return (
            <div className="text-center py-12">
                <ArrowPathIcon className="h-16 w-16 text-emerald-400 mx-auto mb-6 animate-spin" />
                <h3 className="text-xl font-semibold text-white mb-2">Processing Payment Setup</h3>
                <p className="text-gray-400">Please wait while we set up your subscription with GoCardless...</p>
            </div>
        );
    }

    if (paymentStatus === 'success') {
        return (
            <div className="text-center py-12">
                <CheckCircleIcon className="h-16 w-16 text-emerald-400 mx-auto mb-6" />
                <h3 className="text-xl font-semibold text-white mb-2">Payment Setup Complete!</h3>
                <p className="text-gray-400 mb-6">
                    Your subscription has been successfully set up with GoCardless.
                </p>
                <div className="backdrop-blur-sm bg-emerald-900/20 border border-emerald-800/30 rounded-xl p-6">
                    <h4 className="text-lg font-semibold text-emerald-400 mb-2">What's Next?</h4>
                    <ul className="text-gray-300 text-sm space-y-2 text-left">
                        <li>• Your account has been created successfully</li>
                        <li>• You'll receive a confirmation email shortly</li>
                        <li>• Your subscription will begin according to your selected plan</li>
                        <li>• You can now access all venue features</li>
                    </ul>
                </div>
            </div>
        );
    }

    if (paymentStatus === 'failed') {
        return (
            <div className="text-center py-12">
                <XCircleIcon className="h-16 w-16 text-red-400 mx-auto mb-6" />
                <h3 className="text-xl font-semibold text-white mb-2">Payment Setup Failed</h3>
                <p className="text-gray-400 mb-6">
                    There was an issue setting up your subscription with GoCardless.
                </p>
                {paymentError && (
                    <div className="backdrop-blur-sm bg-red-900/20 border border-red-800/30 rounded-xl p-4 mb-6">
                        <p className="text-red-300 text-sm">{paymentError}</p>
                    </div>
                )}
                <div className="space-y-4">
                    <button
                        onClick={onRetry}
                        className="btn-primary"
                    >
                        Try Again
                    </button>
                    <p className="text-gray-500 text-sm">
                        If you continue to experience issues, please contact support.
                    </p>
                </div>
            </div>
        );
    }

    // Default state - ready for payment setup
    return (
        <div className="text-center py-12">
            <div className="backdrop-blur-sm bg-gray-900/20 border border-gray-700/30 rounded-xl p-8 mb-6">
                <h3 className="text-xl font-semibold text-white mb-4">Payment Setup</h3>
                <p className="text-gray-400 mb-6">
                    You'll be redirected to GoCardless to complete your subscription setup.
                </p>
                <div className="text-left space-y-3 text-sm text-gray-300">
                    <p>• Secure payment processing through GoCardless</p>
                    <p>• Easy management of your subscription</p>
                    <p>• Cancel or modify anytime</p>
                    <p>• Automatic billing according to your selected plan</p>
                </div>
            </div>
            <p className="text-gray-500 text-sm">
                Click "Setup Payment" to proceed to GoCardless
            </p>
        </div>
    );
};

export default PaymentStep;
